import type { SVGProps } from 'react';

type DiamondIconProps = SVGProps<SVGSVGElement> & {
  size?: number | string;
};

export function DiamondIcon({
  className,
  size = 24,
  width = size,
  height = size,
  ...props
}: DiamondIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={props['aria-label'] ? undefined : true}
      {...props}
    >
      <path d="M5.4 4.5h13.2L22 9.1 12 21 2 9.1l3.4-4.6Z" fill="currentColor" opacity=".2" />
      <path
        d="m2 9.1 10 11.9L22 9.1m-20 0h20M5.4 4.5h13.2L22 9.1 12 21 2 9.1l3.4-4.6Zm0 0L9 9.1 12 21l3-11.9 3.6-4.6M9 9.1h6"
        stroke="currentColor"
        strokeWidth="1.65"
        strokeLinejoin="round"
      />
    </svg>
  );
}
